import React from "react"
import TicketForm from "../components/support/TicketForm"

const SubmitTicket = ({ sidebarOpen }) => {
	return (
		<div
			className={`bg-gray-50 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 ${sidebarOpen ? "pl-64" : "pl-8"}`}
		>
			<div className="max-w-2xl w-full">
				<TicketForm />
			</div>
		</div>
	)
}

export default SubmitTicket
